import { get } from "lodash";

export default function(value) {
  return `${get(value, "first")} ${get(value, "last")}`;
}
